export const COLUMNS_LIST = [
	{
		id: "question",
		header: "title_question",
		accessorKey: "question",
		enableResizing: true,
	},
	{
		id: "answers",
		header: "title_answer",
		accessorKey: "answers",
		enableResizing: true,
	},
	{
		id: "category",
		header: "title_category",
		accessorKey: "category",
		enableResizing: true,
	},
	{
		id: "created",
		header: "title_created",
		accessorKey: "created",
		enableResizing: true,
	},
];
